// #region Imports
import { lazy } from "react"

const Fluid = lazy(
	() => import("./Fluid")
)
// #endregion

const month = new Date().toLocaleDateString(
    "en-US", 
    {
        year: "numeric",
        month: "long",
    }
)

function Footer() {
	return (
		<footer
			className="
                w-screen h-[100vh] bg-[black] fixed top-0 small:relative  
                z-0 p-16 flex flex-col justify-end items-center font-mada text-ivory
            "
			key="footer"
		>
			<Fluid />

			<aside 
				className="
                    w-[96%] h-[96%] p-10 absolute top-4 border-2 border-chalk 
                    flex flex-col justify-end bg-[#1f1f1f] bluewash rounded-3xl
                    z-100
                "
			>
				<section 
					className="absolute top-10 small:text-sm small:text-center small:self-center"
				>
					<p>
						From here...
					</p>

					<p>
						new chapters await, and
					</p>

					<p>our adventure continues</p>
				</section>

				<section 
                    className="
                        flex justify-between
                        small:flex-col small:items-center small:w-full
                    "
                >
                    <p 
                        className="
                            text-7xl -mb-2

                            small:text-[clamp(3rem,12vw,4rem)]
                            small:leading-[0.9]
                            small:text-center
                            small:mb-[clamp(12rem,32vh,22rem)]
                        "
                    >
                        PRODUCT <br/>
                        ENGINEER
                    </p>
                </section>
			</aside>

            <article className="
                w-fit font-[300] self-end
                z-[100] opacity-70

                small:self-center
                small:flex small:flex-col
                small:items-center
                small:text-center
                small:text-sm
                small:mb-[clamp(1.5rem,5vh,5rem)]
            ">
                <p>{month} © VisShon.</p>

                <section 
                    className="underline flex gap-2 justify-between"
                >
                    <a
                        href="mailto:vshon447@gmail.com"
                        title="Mail: vshon447@gmail.com"
                    >
                        Mail: vshon447@gmail.com
                    </a>
                </section>

                <section>
                    Made with 💜 at{" "}
                    <a
                        className="
                            text-[#bb4bf3] font-[400] hover:brightness-75 
                            transition-all ease-in-out duration-300
                        "
                        target="_blank"
                        title="OpusCo"
                        href="https://www.opusco.dev"
                    >
                        OpusCo
                    </a>
                </section>
            </article>
		</footer>
	)
}

export default Footer
